import React from 'react';
import { View } from '@gin-betting/core';

import { AnalyticAttrs } from 'services/analytics';
import LogoTitle from '../LogoTitle';

import './teamsTitle.scss';

interface Props {
    competitorsValid: View.CompetitorsValid;
    linkToMatch: string | null;
    sportId: string;
    analytics?: Partial<AnalyticAttrs>;
}

const TeamsTitle: React.FC<Props> = ({
    competitorsValid: { awayLogo, awayName, homeLogo, homeName },
    linkToMatch,
    sportId,
    analytics,
}) => {
    return (
        <div
            styleName="container"
            className="__app-TeamsTitle-container"
            {...analytics}
        >
            <LogoTitle
                sportId={sportId}
                logoUrl={homeLogo}
                name={homeName}
                isLogoBeforeTeamName={true}
                linkToMatch={linkToMatch}
            />
            <div styleName="draw" className="__app-TeamsTitle-draw">
                {/* <FormattedMessage {...globalMessages.draw} /> */}X
            </div>
            <LogoTitle
                sportId={sportId}
                logoUrl={awayLogo}
                name={awayName}
                isLogoBeforeTeamName={true}
                linkToMatch={linkToMatch}
            />
        </div>
    );
};

export default TeamsTitle;
